import { render, staticRenderFns } from "./jhi-navbar.vue?vue&type=template&id=fa6045ae"
import script from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa6045ae')) {
      api.createRecord('fa6045ae', component.options)
    } else {
      api.reload('fa6045ae', component.options)
    }
    module.hot.accept("./jhi-navbar.vue?vue&type=template&id=fa6045ae", function () {
      api.rerender('fa6045ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/jhi-navbar/jhi-navbar.vue"
export default component.exports